import moment from 'moment/moment';
import axios from 'axios';
import Photo from '../../../sharedComponents/photo/Photo.vue';
import History from '../components/history/History.vue';

export default {
  components: {
    Photo, History,
  },
  props: ['action_id', 'id'],
  data() {
    return {
      // Адреса
      addresses: [],
      // v-model для адреса
      searchAddress: '',
      // Города
      cities: [],
      // v-model для городов
      searchCity: '',
      // Максимальная дата
      maxDate: moment().format('YYYY-MM-DD'),
      // Процесс отправки монтажа на сохранение/проверку
      submitIsProcessing: false,
      // Правила валидации формы
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
      },
      // Форма добавления монтажа
      form: {
        comment: '',
        date_setup: '',
        date_setup_local: '',
        sale_id: this.$props.id,
        action_id: this.$props.action_id,
        address: '',
        city_id: null,
        positions: [],
        house_in_photos: [],
        house_out_photos: [],
        video_url: '',
      },
      // v-model для формы
      valid: false,
      // Идентификатор продажи
      saleID: this.$props.id,
      // v-model для меню выбора даты монтажа
      dateMenu: false,
    };
  },
  watch: {
    /** Вотчер для автокомплита адресов */
    searchAddress(query) {
      if (query) {
        const app = this;
        const info = { count: 20, query };
        const config = {
          headers: {
            Accept: 'application/json, text/javascript, */*; q=0.01',
            Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
            'Content-Type': 'application/json',
          },
        };

        axios
          .post('https://dadata.ru/api/v2/suggest/address', info, config)
          .then((res) => {
            app.addresses = res.data.suggestions;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    /** Вотчер для автокомплита городов */
    searchCity(val) {
      if (val) {
        this.$store.getters.axl
          .post('location/api/cities/list', { term: val })
          .then((result) => {
            this.cities = result.data.cities;
          });
      }
    },
  },
  computed: {
    // Пользователь
    user() {
      return this.$store.state.user;
    },
    // Акция
    action() {
      return this.$store.state.sales.actions.typical;
    },
    // Акция из маршрута: actions.typical - лишь последняя актуальная акция этого типа
    currentAction() {
      const actionId = Number(this.action_id);
      return (this.$store.state.sales.currentActions ?? [])
        .find(el => el.id === actionId) ?? null;
    },
    // Название акции для заголовка (завершённой акции нет в currentActions - берём из продажи)
    actionTitle() {
      return this.currentAction?.title ?? this.sale?.action?.title ?? null;
    },
    // Отображать ли кнопку "Сохранить черновик"?
    isShowDraftButton() {
      return (
        !this.$store.state.sales.sale?.id
        || this.$store.state.sales.sale?.status === 'draft'
      );
    },
    // История открытой продажи
    history() {
      return this.sale?.history ?? [];
    },
    // Продажа
    sale() {
      return this.$store.state.sales.sale;
    },
    // Процесс выполнения запроса
    loading() {
      return this.$store.state.loading;
    },
    // Возможность редактирования формы
    isEditable() {
      return (
        this.saleID === 'null'
        || !!(
          this.sale
          && this.sale.action.is_actual
          && (this.sale.status === 'draft' || this.sale.status === 'redo')
        )
      );
    },
  },
  created() {
    // При прямом заходе по ссылке список акций ещё не загружен
    if (!this.$store.state.sales.currentActions) {
      this.$store.dispatch('sales/GetActionsList', {
        profile_id: this.user.profile_id,
      });
    }
    this.$store.dispatch('sales/GetSale', +this.saleID).then((res) => {
      if (res) {
        this.$store.dispatch('sales/GetAction', {
          action_id: res.action.id,
        });
      }
    });
  },
  mounted() {
    this.$watch('form.date_setup', (val) => {
      this.form.date_setup_local = val && moment(val).format('DD.MM.YYYY');
    });
  },
};
